<!-- Pannello delle date -->
<section class="date">
  <swiper [config]="config" [(index)]="index" class="date__list">
    <div class="date__single" *ngFor="let date of datesWithSolutions" (click)="onClickOnAlternativeDate(date)"
         [ngClass]="{'date__single--is-selected' : (date | formatDate) === (selectedDate | formatDate)}">
      {{date | formatDate : 'shortDateDayMonth' }}
    </div>
  </swiper>
</section>

<!-- Soluzioni disponibili per la data selezionata -->

<div class="ofe-accordion">
  <section class="solution" *ngIf="solutionsToShow?.length">
    <app-element-loader *ngIf="loadingStatus" class="loader-container" [loadingStatus]="loadingStatus" [loadingMessage]="loadingMessage"></app-element-loader>

    <ngb-accordion *ngIf="!loadingStatus" #a="ngbAccordion" activeIds="panel-{{selectedSolution.dateFrom | formatDate}}-{{selectedSolution.airport}}-{{selectedSolution.dateFrom | formatDate : 'hhmmNoColons'}}">
      <ngb-panel
        id="panel-{{solution.dateFrom | formatDate}}-{{solution.airport}}-{{solution.dateFrom | formatDate : 'hhmmNoColons'}}"
        *ngFor="let solution of solutionsToShow; index as index">

        <ng-template  ngbPanelHeader let-opened="opened">
          <div class="solution__header">
            <div class="solution__toggle__wrapper">
              <button class="solution__toggle__button" ngbPanelToggle
                      *ngIf="solution.flights || solution.parentType === 'Nave + Soggiorno'">
                <i class="solution__toggle__icon icon-{{ opened ? 'minus' : 'plus'}}"></i>
              </button>
            </div>
            <p class="solution__title">
              Soluzione {{index + 1}}

              <span *ngIf="solution.flights">
                da <strong>{{(solution.flights | aptDirection:'ANDATA')?.departureAirport.name }}</strong>
              </span>

              <span *ngIf="solution.parentType === 'Nave + Soggiorno'">
                da <strong>{{ (solution.operatives | operativeDirection:'ANDATA')?.departurePlace.name}}</strong>
                a <strong>{{ (solution.operatives | operativeDirection:'RITORNO')?.departurePlace.name}}</strong>
                - (<strong>{{solution.parentType}}</strong>)
              </span>

              <span *ngIf="solution.parentType === 'Solo Soggiorno'">
                (<strong>{{solution.parentType}}</strong>)
             </span>

            </p>
            <span *ngIf="solution.isCheapest" class="solution__cheapest g-icon-medal">
            </span>

            <!-- Differenza di prezzo rispetto alla selectedSolution -->
            <span class="solution__price-diff">
              <strong>{{ (solution.totalPrice | diffPrice :
                selectedSolution.totalPrice).text }}</strong>
            </span>
            <!-- Pulsante seleziona/to header -->
            <div class="solution__select" [ngClass]="opened ? 'solution__select--desktop-only' : null">
              <button class="btn"
                      (click)="solution === selectedSolution ? null : onClickOnAlternativeSolution(solution)"
                      [ngClass]="solution === selectedSolution ? 'btn--light-blue-outline' : 'btn--light-blue'">
                {{solution === selectedSolution ? 'Selezionato' : 'Seleziona' }}
              </button>
            </div>
          </div>
        </ng-template>

        <ng-template ngbPanelContent *ngIf="solution.flights">
          <div class="flight" *ngIf="solution?.journey?.outward">
            <div class="flight__type">
              <h4 class="flight__type__title">andata</h4>
              <span class="flight__type__airport-name">{{solution.journey.outward.departureAirport?.name}}
                ({{solution.journey.outward.departureAirport?.code}})</span>
              <span class="flight__type__airport-name"
                    *ngIf="solution.journey.outward.stopOver">
                {{solution.journey.outward.stopOver.name}}
                <span *ngIf="((solution.journey.outward.stopOver.id | getDataFromMapping:'airportId') | async)?.Code">
                  ({{((solution.journey.outward.stopOver.id | getDataFromMapping:'airportId') | async)?.Code}})
                </span>
              </span>
              <span class="flight__type__airport-name">{{solution.journey.outward.arrivalAirport?.name}}
                ({{solution.journey.outward.arrivalAirport?.code}})</span>
            </div>
            <div class="flight__steps" [ngClass]="{'flight__steps--outward' : solution.journey.outward.stopOver}">
              <div class="flight__step flight__step--from">
                <span class="flight__step__label">Partenza</span>
                <h4 class="flight__step__time">{{solution.journey.outward.departureHour}}</h4>
                <span class="flight__step__date">{{solution.journey.outward.departureDate | formatDate :
                  'extendedDateDayMonth'}}</span>
                <h4 class="flight__step__apt-code">{{solution.journey.outward.departureAirport?.code}}</h4>
              </div>
              <div class="flight__separator">
                <span class="flight__separator__bar"></span>
              </div>
              <div class="flight__step flight__step--to flight__step--outward"
                   *ngIf="solution.journey.outward.stopOver">
                <span class="flight__step__label">Scalo</span>
                <small class="flight__step__time--outward" *ngIf="solution.journey.outward.stopOverDuration">
                  {{solution.journey.outward.stopOverDuration}}
                </small>
                <h4 class="flight__step__apt-code">
                  {{((solution.journey.outward.stopOver.id | getDataFromMapping:'airportId') | async)?.Code}}
                </h4>
              </div>
              <div class="flight__separator" *ngIf="solution.journey.outward.stopOver">
                <span class="flight__separator__bar"></span>
              </div>
              <div class="flight__step flight__step--to">
                <span class="flight__step__label">Arrivo</span>
                <h4 class="flight__step__time">{{solution.journey.outward.arrivalHour}}</h4>
                <span class="flight__step__date align-self-end">{{solution.journey.outward.arrivalDate | formatDate :
                  'extendedDateDayMonth'}}</span>
                <h4 class="flight__step__apt-code">{{solution.journey.outward.arrivalAirport?.code}}</h4>
              </div>
            </div>
          </div>

          <div class="flight" *ngIf="solution?.journey?.return">
            <div class="flight__type">
              <h4 class="flight__type__title">ritorno</h4>
              <span class="flight__type__airport-name">{{solution.journey.return.departureAirport?.name}}
                ({{solution.journey.return.departureAirport?.code}})</span>
              <span class="flight__type__airport-name"
                    *ngIf="solution.journey.return.stopOver">
                {{solution.journey.return.stopOver.name}}
                <span *ngIf="((solution.journey.return.stopOver.id | getDataFromMapping:'airportId') | async)?.Code">
                  ({{((solution.journey.return.stopOver.id | getDataFromMapping:'airportId') | async)?.Code}})
                </span>
              </span>
              <span class="flight__type__airport-name">{{solution.journey.return.arrivalAirport?.name}}
                ({{solution.journey.return.arrivalAirport?.code}})</span>
            </div>
            <div class="flight__steps" [ngClass]="{'flight__steps--outward' : solution.journey.outward.stopOver}">
              <div class="flight__step flight__step--from">
                <span class="flight__step__label">Partenza</span>
                <h4 class="flight__step__time">{{solution.journey.return.departureHour}}</h4>
                <span class="flight__step__date">{{solution.journey.return.departureDate | formatDate :
                  'extendedDateDayMonth'}}</span>
                <h4 class="flight__step__apt-code">{{solution.journey.return.departureAirport?.code}}</h4>
              </div>
              <div class="flight__separator">
                <span class="flight__separator__bar"></span>
              </div>
              <div class="flight__step flight__step--to flight__step--outward" *ngIf="solution.journey.return.stopOver">
                <span class="flight__step__label">Scalo</span>
                <small class="flight__step__time--outward" *ngIf="solution.journey.return.stopOverDuration">
                  {{solution.journey.return.stopOverDuration}}
                </small>
                <h4 class="flight__step__apt-code"
                    *ngIf="((solution.journey.return.stopOver.id | getDataFromMapping:'airportId') | async)?.Code">
                  {{((solution.journey.return.stopOver.id | getDataFromMapping:'airportId') | async)?.Code}}
                </h4>
              </div>
              <div class="flight__separator" *ngIf="solution.journey.return.stopOver">
                <span class="flight__separator__bar"></span>
              </div>
              <div class="flight__step flight__step--to">
                <span class="flight__step__label">Arrivo</span>
                <h4 class="flight__step__time">{{solution.journey.return.arrivalHour}}</h4>
                <span class="flight__step__date align-self-end">{{solution.journey.return.arrivalDate | formatDate :
                  'extendedDateDayMonth'}}</span>
                <h4 class="flight__step__apt-code">{{solution.journey.return.arrivalAirport?.code}}</h4>
              </div>
            </div>
          </div>
          <!-- Pulsante seleziona/to solo mobile -->
          <div *ngIf="!opened" class="solution__select solution__select--mobile-only">
            <button class="btn" (click)="solution === selectedSolution ? null : onClickOnAlternativeSolution(solution)"
                    [ngClass]="solution === selectedSolution ? 'btn--light-blue-outline' : 'btn--light-blue'">
              {{solution === selectedSolution ? 'Selezionato' : 'Seleziona' }}
            </button>
          </div>
        </ng-template>



        <ng-template ngbPanelContent *ngIf="solution.parentType === 'Nave + Soggiorno'">
          <div class="flight" *ngIf="(solution.operatives | operativeDirection:'ANDATA')">
            <div class="flight__type">
              <h4 class="flight__type__title">andata</h4>
            </div>
            <div class="flight__steps">
              <div class="flight__step flight__step--from">
                <span class="flight__step__label">Partenza</span>
                <strong class="flight__step__label">{{(solution.operatives | operativeDirection:'ANDATA')?.departureDate | formatDate :
                  'hhmm'}}</strong>
                <span class="flight__step__time"> {{(solution.operatives | operativeDirection:'ANDATA')?.departureDate | formatDate :
                  'extendedDateDayMonth'}}</span>
                  <span class="flight__type__airport-name">{{ (solution.operatives | operativeDirection:'ANDATA')?.departurePlace.name}}</span>
              </div>
              <div class="flight__separator flight__separator--cruise">
                <span class="flight__separator__bar"></span>
              </div>
              <div class="flight__step flight__step--to">
                <span class="flight__step__label">Arrivo</span>
                <strong class="flight__step__label">{{(solution.operatives | operativeDirection:'ANDATA')?.arrivalDate | formatDate :
                  'hhmm'}}</strong>
                <span class="flight__step__time"> {{(solution.operatives | operativeDirection:'ANDATA')?.arrivalDate | formatDate :
                  'extendedDateDayMonth'}}</span>
                  <span class="flight__type__airport-name">{{ (solution.operatives | operativeDirection:'ANDATA')?.arrivalPlace.name}}</span>
              </div>
            </div>
          </div>

          <div class="flight" *ngIf="(solution.operatives | operativeDirection:'RITORNO')">
            <div class="flight__type">
              <h4 class="flight__type__title">ritorno</h4>
            </div>
            <div class="flight__steps">
              <div class="flight__step flight__step--from">
                <span class="flight__step__label">Partenza</span>
                <strong class="flight__step__label">{{(solution.operatives | operativeDirection:'RITORNO')?.departureDate | formatDate :
                  'hhmm'}}</strong>
                <span class="flight__step__time"> {{(solution.operatives | operativeDirection:'RITORNO')?.departureDate | formatDate :
                  'extendedDateDayMonth'}}</span>
                  <span class="flight__type__airport-name">{{ (solution.operatives | operativeDirection:'RITORNO')?.departurePlace.name}}</span>
              </div>
              <div class="flight__separator flight__separator--cruise">
                <span class="flight__separator__bar"></span>
              </div>
              <div class="flight__step flight__step--to">
                <span class="flight__step__label">Arrivo</span>
                <strong class="flight__step__label">{{(solution.operatives | operativeDirection:'RITORNO')?.arrivalDate | formatDate :
                  'hhmm'}}</strong>
                <span class="flight__step__time"> {{(solution.operatives | operativeDirection:'RITORNO')?.arrivalDate | formatDate :
                  'extendedDateDayMonth'}}</span>
                  <span class="flight__type__airport-name">{{ (solution.operatives | operativeDirection:'RITORNO')?.arrivalPlace.name}}</span>
              </div>

            </div>
          </div>
          <!-- Pulsante seleziona/to solo mobile -->
          <div *ngIf="!opened" class="solution__select solution__select--mobile-only">
            <button class="btn" (click)="solution === selectedSolution ? null : onClickOnAlternativeSolution(solution)"
                    [ngClass]="solution === selectedSolution ? 'btn--light-blue-outline' : 'btn--light-blue'">
              {{solution === selectedSolution ? 'Selezionato' : 'Seleziona' }}
            </button>
          </div>
        </ng-template>

      </ngb-panel>
    </ngb-accordion>
  </section>
  <section class="solution" *ngIf="!solutionsToShow?.length">
    <div class="solution__not-available">
      <p class="solution__not-available__text">
        Non è più disponibile nessuna soluzione per {{ selectedDate | formatDate : 'extendedDateDayMonthYear' }}. Prova
        a scegliere un'altra data.
      </p>
    </div>
  </section>
</div>
